/* eslint-disable import/prefer-default-export */
export const formatNumber = (number = 0) => new Intl.NumberFormat().format(number);
